var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"b-container px-0",attrs:{"fluid":""}},[_c('v-sheet',{staticClass:"pa-3"},[_c('Viber',{staticClass:"my-2"}),_c('Sms',{staticClass:"my-2"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }